// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__v4Zgp","shimmer":"Skeleton_shimmer__85wvm"};